import { Directive, TemplateRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[carouselItem]'
})
export class CarouselSlideTemplateDirective {
  public index: number;
  constructor(public tpl: TemplateRef<any>) {}
}
